import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import {PartnerFilter, PartnerItem, PartnersState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<PartnersState, RootState> = {
  getPartners: ({commit, dispatch},data) => {
    return new Promise((resolve, reject) => {
      // commit('setLoading', true);
      axios({url: '/acapi/partners',params: {
          id: data?.id,
          name: data?.name,
          transports: Array.isArray(data?.transport) ? data?.transport?.join() : data?.transport,
          status: data?.status,
          prepaid: data?.prepaid,
          query: data?.query,
          page_number: data?.page_number,
          page_size: data?.page_size,
          order_by: data?.order_by,
          order_direction: data?.order_direction
        }})
        .then(resp => {
            if (data?.page_number > 1) {
                commit("pushPartners", resp.data.partners);
            } else {
                commit('setPartners', resp.data.partners);
            }
          resolve(resp.data.partners)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPartnerItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/partners/${id}`})
        .then((resp:any) => {
          let partnerItem = <PartnerItem>resp.data;
          partnerItem.id = id;
          commit('setPartnerItem', partnerItem);
          resolve(partnerItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  savePartner: ({commit, dispatch}, data:PartnerItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/partners/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getPartners');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deletePartner: ({commit, dispatch}, data: PartnerItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/partners/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getPartners');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  exportPartners: ({commit, dispatch}, data: PartnerFilter) => {
    let data1 = {
      id: data?.id,
      name: data?.name,
      transports: Array.isArray(data?.transport) ? data?.transport?.join() : data?.transport,
      status: data?.status,
    }
    return directDownload('/acapi/partners/export', data1)
  },
};
